import React, { useEffect } from "react";
import { Input } from "../../../../../../_metronic/_partials/controls";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/socialconfig/socialconfigActions";
import { TextArea } from "../../../../../../_metronic/_partials/controls/forms/TextArea";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Card } from "react-bootstrap";

const Socialconfig = {
  _id: undefined,
  appId: "",
  appSecret: "",
  appPage: "",
  shareText: "",
};
const SocialconfigEditSchema = Yup.object().shape({
  appId: Yup.string()
    .min(1, "Minimum 1 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Facebook App ID is required"),
  appSecret: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Facebook App Secret is required"),
  appPage: Yup.string().required("Facebook Page is required"),
  shareText: Yup.string().required("Share Text is required"),
});
function FacebookEditForm({name}) {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { actionsLoading, socialconfigForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.socialconfig.actionsLoading,
      socialconfigForEdit: state.socialconfig.socialconfigForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    // server call for getting Network by id
    dispatch(actions.fetchSocialconfig(user._id));
  }, [user, dispatch]);
  const saveSocialconfig = (socialconfig) => {
    if (!socialconfig._id) {
      socialconfig.adminId = user._id;
      socialconfig.name=name;
      // server request for creating network
      dispatch(actions.createSocialconfig(socialconfig)).then();
    } else {
      // server request for updating network
      dispatch(actions.updateSocialconfig(socialconfig)).then();
    }
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={socialconfigForEdit || Socialconfig}
      validationSchema={SocialconfigEditSchema}
      onSubmit={(values) => {
        
        saveSocialconfig(values);
      }}
    >
      {({ handleSubmit }) => (
        <>
          <Form className="form form-label-right ">
          <Card.Header>
            <div className="form-group row">
              {/* Product Name */}
              <div className="col-lg-10">
                <Field
                  name="appId"
                  component={Input}
                  placeholder="Facebook App ID"
                  label="Facebook App ID"
                />
              </div>
              {/* Moto Name */}
              <div className="col-lg-10">
                <Field
                  name="appSecret"
                  component={Input}
                  placeholder="Facebook App Secret"
                  label="Facebook App Secret"
                />
              </div>
            </div>
            </Card.Header>
            <Card.Footer>
            <div className="form-group row">
              {/* Domain Name */}
              <div className="col-lg-10">
                <Field
                  name="appPage"
                  component={Input}
                  placeholder="Facebook Page"
                  label="Facebook Page"
                />
              </div>
              {/* Domain Shortcut */}
              <div className="col-lg-10">
                <Field
                  name="shareText"
                  component={TextArea}
                  placeholder="Share message"
                  label="Share message"
                />
              </div>
            </div>
            </Card.Footer>
          </Form>
          <div className="form-group row">
            {/* Endpoint Name */}
            <div className="col-lg-6">
              <button
                type="button"
                onClick={() => handleSubmit()}
                className="btn btn-primary btn-elevate"
              >
                Save
              </button>
              {actionsLoading && (
                <div
                  style={{ float: "right" }}
                  className="overlay-layer bg-transparent"
                >
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </Formik>
  );
}

export default FacebookEditForm;
